module.exports = __webpack_public_path__ + "9b1f57ea42be8777f2168a08bf2dbb03.svg";